var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadLic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_lic",
    transform: "translate(-1653 -628)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11410",
    "data-name": "Rectangle 11410",
    width: 24,
    height: 24,
    transform: "translate(1653 628)",
    fill: "#0074d7",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_download",
    d: "M11,2a1,1,0,0,0-1,1v8H6.5a.5.5,0,0,0-.354.853l.031.029L11.283,16.7l.033.031a1,1,0,0,0,1.367,0l.014-.012.01-.012,5.1-4.812.029-.027.008-.006.006-.006A.5.5,0,0,0,17.5,11H14V3a1,1,0,0,0-1-1H11ZM3,20a1,1,0,1,0,0,2H21a1,1,0,1,0,0-2Z",
    transform: "translate(1653 628)",
    fill: "#0074d7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLic);
export default __webpack_public_path__ + "static/media/download_lic.565ed69f12adead8edf2860c94d1ae5e.svg";
export { ForwardRef as ReactComponent };